import { createContext } from "react"

export const IslandLaneContext = createContext(false)

export const IslandWidthContext = createContext(0)

export const AskPanelBottomContext = createContext(0)

export const ISLAND_LANE_GAP = 8

interface Extent {
    left: number
    width: number
}

export function isUnderIsland({
    items,
    viewportWidth,
    islandWidth,
}: {
    items: Extent[]
    viewportWidth: number
    islandWidth: number
}): boolean {
    if (islandWidth <= 0) return false
    const bandStart = viewportWidth / 2 - islandWidth / 2 - ISLAND_LANE_GAP
    const bandEnd = viewportWidth / 2 + islandWidth / 2 + ISLAND_LANE_GAP
    return items.some(
        item =>
            item.width > 0 &&
            item.left < bandEnd &&
            item.left + item.width > bandStart
    )
}
